import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateDiff'
})

export class DateDiffPipe implements PipeTransform {
    transform(date1: Date, date2: Date): number {

        if (!date1 || !date2) {
            return 0;
        }

        const diffInMs = date1.getTime() - date2.getTime()
        return diffInMs

    }
}